import React from 'react';

const ListContext = React.createContext({
  list: [],
  current_page: null,
  last_page: null,
});
export default ListContext;
